export default {
    connect: {
        /**
         * The connection will be retried x times
         */
        retries: 5,

        /**
         * Wait x seconds between retries
         */
        delay: 1,
    },
};
